<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      // this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      let _this = this;
      
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          backgroundColor:'rgba(255,255,255,1)'
        },
        // legend: {
        //   data: ["新增数", "完成数"],
        //   right: 0,
        //   textStyle: {
        //     color: _this.isbig ? "#AABEFF" : "",
        //   },
        // },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          top: "5%",
          containLabel: true,
        },

        xAxis: {
          show: true,
          type: "category",
          // boundaryGap: false,
          axisLabel: {
            interval: 0,
          },
          data: data.xAxisData,
        },
        yAxis: {
          type: "value",
          splitArea: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "#333",
          },
          splitLine: {
            lineStyle: {
              color: _this.isbig ? "#1A48DD" : "#ddd",
            },
          },
        },
        series: [
          {
            name: "新增数",
            type: "bar",
            stack: "总量",
            data: data.seriesData,
            barMaxWidth: 24,
          },
          // {
          //   name: "完成数",
          //   type: "line",
          //   stack: "总量",
          //   data: [220, 182, 191, 234, 290, 330, 310],
          //   smooth: 0,
          // },
        ],
      });
    },
  },
};
</script>
